import React from 'react';
import { Container, Row } from 'react-bootstrap';

export default class Coach extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {

        return (
            <>
                <Container>
                    <Row> &nbsp; </Row>
                    <Row> &nbsp; </Row>
                    <Row> &nbsp; </Row>
                    <Row>
                        <b> Страница в разработке </b>
                    </Row>
                </Container>
            </>
        )
    }
}